export default __webpack_public_path__ + "static/media/bloodpact.8ca124f3.png";